<template>
  <div class="person-list">
    <div class="search-line">
      <div class="left">
        <el-input v-model="queryParams.name" class="search-input" :placeholder="`名称`"></el-input>
        <el-input v-model="queryParams.id" class="search-input" :placeholder="`ID`"></el-input>
        <el-button type="primary" size="small" @click="search()">查询</el-button>
        <el-button size="small" icon="el-icon-plus" type="primary" @click="goNew()">新建</el-button>
      </div>
    </div>
    <div class="list-content">
      <el-table
        :data="list"
        :header-cell-class-name="'table-header-cell'"
        @sort-change="sortChange"
        border
      >
        <el-table-column
          v-for="(item) in tableHeaders"
          :key="item.id"
          :type="item.type"
          :label="item.label"
          :prop="item.prop"
          :sortable="!!item.sortKey ? 'custom': false"
          :sort-by="item.sortKey"
          :width="item.width">
            <template slot-scope="scope">
              <span v-if="item.type ==='index'">{{scope.$index + 1}}</span>
              <span v-else>{{scope.row[item.prop]}}</span>
              <el-tooltip v-if="item.handle" effect="dark" :content="`编辑`" placement="top-start">
                <el-button class="p0 fontsize20" type="text" @click.prevent="goEdit(scope.row)"><i class="el-icon-edit-outline"></i></el-button>
              </el-tooltip>
              <el-tooltip v-if="item.handle" effect="dark" :content="`删除`" placement="top-start">
                <el-button class="p0 fontsize20" type="text" @click.prevent="goDelete(scope.row.id)"><i class="el-icon-delete"></i></el-button>
              </el-tooltip>
            </template>
        </el-table-column>
      </el-table>
      <pagination :queryParams="queryParams" :getList="getList" />
    </div>
  </div>
</template>

<script>
import Pagination from '@/components/common/Pagination.vue'
import { functionList, functionDelete } from '@/api.js'
import { pageSize } from '@/utils/Config.js'
export default {
  name: 'PersonList',
  components: {
    Pagination
  },
  data() {
    return {
      queryParams: { // 请求参数
        name: undefined,
        id:'',
        pageIndex: 1,
        pageSize,
        _total: 0
      },
      tableHeaders: [],
      list: []
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    search() {
      this.queryParams.pageIndex = 1
      this.getList()
    },
    getList() {
      // 获取列表数据
      const url = functionList
      const {
        pageIndex,
        pageSize,
        name,
        id,
        orderBy,
        order
      } = this.queryParams
      const queryParams = {
        page: pageIndex,
        per_page: pageSize,
        name,
        id,
        order_column: orderBy,
        order
      }
      this.$request('get', url, queryParams)
      .then((res) => {
        if (res) {
          const prev = [
            {
              width: 60,
              label: '#',
              prop: '',
              type: 'index',
              checked: true
            }
          ]
          const last = [
            {
              width: 'auto',
              label: `操作`,
              prop: '',
              checked: true,
              handle: true
            }
          ]
          this.tableHeaders = this.tableHeaders.length > 0 ? this.tableHeaders : this.$utils.generateColumns(res.columns, prev, last)
          this.list = res.data
          this.queryParams._total = res.total
        }
      })
    },
    sortChange(item) {
      // 排序方法
      const { column, order } = item
      const orderString = order ? order === 'ascending' ? 'asc' : 'desc' : undefined
      const orderBy = order ? column.sortBy : undefined

      this.queryParams.order = orderString
      this.queryParams.orderBy = orderBy
      this.getList()
    },
    goEdit(item) {
      // 调转编辑页
      this.$router.push(`/basic/function/edit/${item.id || 0}`)
    },
    goNew() {
      // 跳转新建
      this.$router.push(`/basic/function/edit/0`)
    },
    goDelete(id) {
      // 确认删除
      this.$confirm(`确认删除吗?`)
      .then(() => {
        const url = functionDelete.replace('{id}', id)
        this.$request('post', url, {})
        .then((res) => {
          if (res) {
            this.$message.success(`删除成功`)
            this.getList()
          }
        })
      })
      .catch(() => {
        console.log('取消删除')
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/css/common.scss';
  .person-list {
    position: relative;
    .search-line {
      display: flex;
      justify-content: space-between;
    }
    .list-content {
      border-radius: 10px;
      background-color: #fff;
      margin: 10px auto 0;
      padding: 10px 0;
      position: relative;
    }
  }
</style>